module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-info"
  }, [_c('div', {
    staticClass: "popup-info__content"
  }, [_vm._m(0), _vm._v(" "), (!_vm.isGuest) ? _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "/profile"
    }
  }, [_vm._v("ДАЛЕЕ")]) : _c('a', {
    staticClass: "btn guest",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.showAuthPopup
    }
  }, [_vm._v("Авторизоваться")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "popup-info__title popup__title"
  }, [_vm._v("\n\t\t\t1. ПОВТОРИ В FIFA 18 ЛЮБОЙ ЗНАМЕНИТЫЙ ГОЛ"), _c('br'), _vm._v(" ИЗ ФУТБОЛЬНОЙ ИСТОРИИ"), _c('br'), _vm._v("\n\t\t\t2. ПРИШЛИ НАМ ССЫЛКУ НА ВИДЕО"), _c('br'), _vm._v("\n\t\t\t3. И НЕ ЗАБУДЬ УКАЗАТЬ КОМАНДЫ И ДАТУ ЭТОГО МАТЧА.\n\t\t")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca355420","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/popups/Info.vue
// module id = 513
// module chunks = 1